import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Menu } from 'antd';
import { TableOutlined } from '@ant-design/icons';
import classnames from 'classnames';

import Messages from 'i18n/messages/home';
import {
  RIBBON_TYPES,
  pathnameProduct,
  pathnameFavProducts,
} from 'static/Constants';
import ButtonSmallIcon from 'common/components/button/ButtonSmallIcon';
import { selectRibbonType } from '@redux/ribbon/selectors';

import {
  GridColumnsControl,
  SaveGridControl,
  ManageQuery,
  SavedConfigurations,
  ClearQuery,
} from '../../index';

import './GridLayout.less';
import { useCreateQueryForm } from '../../controls/home/grid-query/hooks';
import CreateQueryModal from '../../controls/home/grid-query/CreateQueryModal';

import ManageQueriesModal from '../../controls/home/grid-query/ManageQueriesModal';

const { SubMenu } = Menu;

const GridConfig = (props) => {
  const { disabledOption } = props;
  const [visible, setVisible] = React.useState(false);
  const [visibleManageQueries, setVisibleManageQueries] = useState(false);

  const [isMounted, setIsMounted] = React.useState(true);

  const ribbonTypes = useSelector(selectRibbonType());

  const {
    toggleCuratedQuery,
    shareType,
    setShareType,
    handleCreateConfig,
    form,
    selectedMembers,
    setSelectedMembers,
    setCuratedQuery,
    gridName,
    memberRoles,
    statusCreate,
  } = useCreateQueryForm();

  const isDisabledChooseColumns =
    pathnameProduct !== window.location.pathname ||
    pathnameFavProducts !== window.location.pathname;

  const displayChooseColumns =
    ribbonTypes === RIBBON_TYPES.DETAILSVIEW && !isDisabledChooseColumns;

  return (
    <>
      <Menu
        className={classnames('grid-config__menu', {
          'grid-config--menu-disabled': disabledOption,
        })}
        mode='vertical'
        style={{ padding: 3 }}
      >
        <SubMenu
          key='gridConfig'
          title={
            <ButtonSmallIcon
              icon={<TableOutlined />}
              label={Messages.gridConfig}
              className='grid-config__button'
            />
          }
          disabled={disabledOption}
        >
          {displayChooseColumns && (
            <Menu.Item
              key='chooseColumns'
              style={{ backgroundColor: 'inherit', padding: 0 }}
            >
              <GridColumnsControl />
            </Menu.Item>
          )}

          <Menu.Item
            key='savedConfig'
            style={{ backgroundColor: 'inherit', padding: 0 }}
          >
            <SavedConfigurations
              setVisible={setVisible}
              isMounted={isMounted}
            />
          </Menu.Item>
          <Menu.Item
            key='saveConfig'
            style={{ backgroundColor: 'inherit', padding: 0 }}
          >
            <SaveGridControl setIsMounted={setIsMounted} />
          </Menu.Item>
          <Menu.Item
            key='clearConfig'
            style={{ backgroundColor: 'inherit', padding: 0 }}
          >
            <ClearQuery />
          </Menu.Item>

          <Menu.Item
            key='manageConfig'
            style={{ backgroundColor: 'inherit', padding: 0 }}
          >
            <ManageQuery
              setIsMounted={setIsMounted}
              setVisibleManageQueries={setVisibleManageQueries}
            />
          </Menu.Item>
        </SubMenu>
      </Menu>
      <CreateQueryModal
        handleCreateConfig={handleCreateConfig}
        statusCreate={statusCreate}
        form={form}
        setIsMounted={setIsMounted}
        selectedMembers={selectedMembers}
        setSelectedMembers={setSelectedMembers}
        toggleCuratedQuery={toggleCuratedQuery}
        setCuratedQuery={setCuratedQuery}
        gridName={gridName}
        shareType={shareType}
        setShareType={setShareType}
        memberRoles={memberRoles}
      />
      {visibleManageQueries && (
        <ManageQueriesModal
          setIsMounted={setIsMounted}
          visibleManageQueries={visibleManageQueries}
          setVisibleManageQueries={setVisibleManageQueries}
        />
      )}
    </>
  );
};

GridConfig.propTypes = {
  disabledOption: PropTypes.bool,
};

export default GridConfig;
